function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ((useActualHostSelector ? ":host div.agentx-badge-group" : hostSelector + " div.agentx-badge-group")) + shadowSelector + " {display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;}" + ((useActualHostSelector ? ":host div.agentx-badge-group" : hostSelector + " div.agentx-badge-group")) + shadowSelector + " > .wp-block-image" + shadowSelector + " {margin-bottom: 0;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];